import React, { Component } from "react";
//// componentes reutilizables

import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import TransferenciasService from "../../../../services/transferencias/TransferenciasService";
import {
  formatoSeparadorMilesReturn,
  splitImporte,
} from "../../../generico/utils/FormatoInput";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import ConfigService from "../../../../services/configuracion/ConfigService";


export default class TransferenciaInterentidad extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    
  }
  muestraEntrust = false;
  muestraOtp = false;
 

  getInitialState = () => ({
    isValid:true,
    monto: 0,
    motivo: "",
    codigo: 0,
    nroOperacion: 0,
    disableSgte: true,
    otrosDesc: "",
    listaMotivos: [],
    listaOTP: []
  });

  resetState = () => {
    this.setState(this.getInitialState());
    this.obtenerMotivosTransferencia();
  };

  componentDidMount() {
    this.obtenerMotivosTransferencia();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerMotivosTransferencia = () => {
    trackPromise(
      TransferenciasService.getMotivosTransferencia()
        .then(({ data }) => {
          if (data.codigo === 0) {

            this.setState({ listaMotivos: data.datos });

          } else {
            console.log(data);
          }
        })
        .catch(error => {
          console.log(error);
        })
    )
  }



  enableNext(monto, motivo, otrosDesc) {
    if (monto !== "") {
      if (motivo !== "" && motivo !== "Otros") {
        this.state.disableSgte = false;
      } else {
        if (motivo === "Otros" && otrosDesc !== "") {
          const patron = /^[a-zA-Z0-9\s]*$/;
          if( patron.test(otrosDesc) ){
            this.state.disableSgte = false;
            this.setState({isValid:true});
          }else{
            this.setState({isValid:false});
            this.state.disableSgte = true;
          }
        } else {
          this.state.disableSgte = true;
        }
      }

    } else {
      this.state.disableSgte = true;
    }
  }

  verificarEntrustyOtp = () => {
    const tokenActivo = sessionStorage.getItem('tieneToken');
    tokenActivo === "S" && ConfigService.ocultarSegunNombre("entrust") === null ? 
    this.muestraEntrust = true : this.muestraEntrust = false;

    ConfigService.ocultarSegunNombre('otpSms') === null ?
    this.muestraOtp = true : this.muestraOtp = false;
  }

  handleContinuar = () =>{
    this.verificarEntrustyOtp();
    var _motivo = (this.state.motivo === "Otros" ? this.state.otrosDesc : this.state.motivo);
    if( this.props.currentStep === 2 ){
      if( !this.muestraEntrust && !this.muestraOtp ){
        Popup.queue(this.notifiPopup("Error", 'Para completar esta operación, por favor activa un token de seguridad en tu cuenta'));
      }else{
        if( !this.muestraEntrust ){
          this.setState({ disableSgte: true });
          TransferInterbancaService.generarOTP()
          .then(( response ) => {
            if(response.data.codigo === 0){
              
              const datogenerado = response.data.datos
              this.props.returnDataPaso2(this.state.monto, _motivo, datogenerado);
              this.setState({ disableSgte: false });
            this.props.nextStep();
            }
            else if(response.data.codigo === 2 || response.data.codigo === 1 ){
              Popup.queue(this.notifiPopup("Error", response.data.mensaje));
              this.setState({ disableSgte: false });
            }
            else{
              Popup.queue(this.notifiPopup("Error", "Ha ocurrido un error"));
              this.setState({ disableSgte: false });
            }
          })
          .catch(error => {
            console.log(error);
            this.setState({ disableSgte: false });
          })
        }else{
          this.props.returnDataPaso2(this.state.monto, _motivo, "",this.muestraEntrust);
          this.setState({ disableSgte:false });
          this.props.nextStep();
        }

      }
    }
  }

  pasarOTP(){
    var _motivo = (this.state.motivo === "Otros" ? this.state.otrosDesc : this.state.motivo)
                   
    if (this.props.currentStep === 2) {
      this.setState({ disableSgte: true });
      TransferInterbancaService.generarOTP()
      .then(( response ) => {
        if(response.data.codigo === 0){
          const datogenerado = response.data.datos
          this.props.returnDataPaso2(this.state.monto, _motivo, datogenerado);
          this.setState({ disableSgte: false });
         this.props.nextStep();
        }
        else if(response.data.codigo === 2 || response.data.codigo === 1 ){
          Popup.queue(this.notifiPopup("Error", response.data.mensaje));
          this.setState({ disableSgte: false });
        }
        else{
          Popup.queue(this.notifiPopup("Error", "Ha ocurrido un error"));
          this.setState({ disableSgte: false });
        }
        })
        .catch(error => {
          console.log(error);
          this.setState({ disableSgte: false });
        })                   
    
    
    }
  }

  render() {
    return (
      <div>
        <form id="idFormPaso2" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Selección de Cuentas
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Código de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row justify-content-md-center">
            <div className="col-lg-6 col-md-10">
              <div className="form-group">
                <label className="input-label-bold">Importe a Transferir *</label>
                <input
                  value={this.state.monto}
                  type="text"
                  maxLength="19"
                  name="monto"
                  className="form-control input-box"
                  onChange={(evt) => {
                    var _monto = formatoSeparadorMilesReturn(evt);
                    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                      _monto = _monto.substr(1);
                    }
                    this.setState({
                      monto: _monto,
                    });
                    _monto = splitImporte(_monto);
                    this.enableNext(parseFloat(_monto), this.state.motivo, this.state.otrosDesc);
                  }}
                />
              </div>
              <div className="form-group">
                <label className="input-label-bold">
                  Motivo de la Transferencia *
                </label>
                <select
                  value={this.state.motivo}
                  className="form-control input-box"
                  onChange={(evt) => {
                    this.setState({ motivo: evt.target.value, });
                    this.enableNext(this.state.monto, evt.target.value, this.state.otrosDesc);
                  }}
                >
                  <option key="-1" value="" disabled>--Seleccione--</option>
                  {
                    this.state.listaMotivos.map((motivo, index) => (
                      <option value={motivo} key={index}>{motivo}</option>
                    ))
                  }
                </select>
              </div>

              <div className="form-group">
                {this.state.motivo === "Otros" && (
                  <textarea
                    id="motivoDescripcion"
                    style={{borderColor:this.state.isValid?'initial':'red'}}
                    rows="4"
                    cols="50"
                    value={this.state.otrosDesc}
                    name="otrosDsc"
                    className="form-control input-box"
                    maxLength="59"
                    onChange={(evt) => {
                      this.setState({ otrosDesc: evt.currentTarget.value });
                      this.enableNext(this.state.monto, this.state.motivo, evt.currentTarget.value);
                    }}
                  ></textarea>
                )}
                  {this.state.isValid===false && (
                    <p style={{color:'red',fontSize:'0.9rem'}}> 
                       Solo letras, números y espacios son permitidos.
                    </p>
                  )} 
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-lg-8 col-md-6">
                <label
                  className="input-label-bold-obligatorio">
                  (*) Campos Obligatorios
                  <br />
                </label>
            </div>
            <div className="col-lg-2 col-md-3">
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={() => {
                    this.props.previousStep();
                    
                  }}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>

            </div>
            <div className="col-lg-2 col-md-3">
            <button
                  className="btn btn-cu-primary"
                  disabled={this.state.disableSgte}
                  onClick={() => {
                    this.handleContinuar();
                  }}
                >
                  Continuar <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
          </div>

        </form>
      </div>
    );
  }
}
